import createReducer from 'Lib/createReducer';

export const OPEN_NOTE_EDITOR = 'OPEN_NOTE_EDITOR';
export const RESET_ANNOTATION = 'RESET_ANNOTATION';
export const SAVE_ANNOTATION_POSITION = 'SAVE_ANNOTATION_POSITION';
export const SET_TOUCH_EVENT_STATUS = 'SET_TOUCH_EVENT_STATUS';


const initialState = {
  position: {},
  isOpen: false,
  isMain: true,
  textSelected: false,
  highlightClicked: false,
  noteClicked: false,
  touchEventInProgress: false,
  isTouchScreen: false
};

const actionHandlers = {
  [RESET_ANNOTATION]: (state, action) => {
    const touchState = {
      isTouchScreen: state.isTouchScreen,
      touchEventInProgress: state.touchEventInProgress
    };
    return { ...initialState, ...touchState };
  },

  [SAVE_ANNOTATION_POSITION]: (state, action) => {
    return { ...state, ...action.data };
  },

  [SET_TOUCH_EVENT_STATUS]: (state, action) => {
    return { ...state, ...action.data };
  }
};


export default createReducer(initialState, actionHandlers);


/**
 * NOTE
 * Combine mainslat & noteslat reducers
 */
